import { WindowEventTopic } from '@/common/interop/window';

const windowListeners = new Map<WindowEventTopic, Set<() => void>>();

function handleWindowMessage(event: MessageEvent) {
  if (!event.data) return;
  try {
    const authEvent =
      typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
    const listeners = windowListeners.get(authEvent.topic) || new Set();
    listeners.forEach((listener) => listener());
  } catch (err) {
    // ignored
  }
}

let isRegistered = false;

function registerWindowMessageHandler() {
  if (isRegistered) return;
  isRegistered = true;
  window.addEventListener('message', handleWindowMessage);
}

function addWindowListener(topics: WindowEventTopic, listener: () => void) {
  registerWindowMessageHandler();

  let listeners = windowListeners.get(topics);
  if (!listeners) {
    listeners = new Set();
    windowListeners.set(topics, listeners);
  }
  listeners.add(listener);
}

function removeWindowListener(topics: WindowEventTopic, listener: () => void) {
  windowListeners.get(topics)?.delete(listener);
}

export function waitForWindowEvent(...topics: WindowEventTopic[]) {
  return new Promise<WindowEventTopic>((res) => {
    const removeListeners: (() => void)[] = [];
    topics.forEach((topic) => {
      const handleEvent = () => {
        removeListeners.forEach((listener) => listener());
        res(topic);
      };
      removeListeners.push(() => removeWindowListener(topic, handleEvent));
      addWindowListener(topic, handleEvent);
    });
  });
}
